import { getRootDeputyFrame } from '@webapp-next/global-libs/deputy-embed';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import RouterFakeComponent from '@webapp-next/router/router-fake-component';

import { RouteParams } from 'vue-router';
import { Component } from '@vue/runtime-core';
import {
  RouterWrapper,
  RouterWrapperRoute,
  RouterWrapperRouteParams,
} from '@/lib/types/router';

export type WebappVueRoute = {
  path?: string;
  name: string;
  params?: RouteParams;
  component?: void | Component | Promise<Component | void>;
  webappVueComponent?: WebappVueRoute['component'];
  webappVueRedirect?: WebappVueRoute | (() => string) | string;
  redirect?: WebappVueRoute | (() => string) | string;
  isWebappVueRoute?: boolean;
  alias?: string | string[];
  value?: RouterWrapperRoute;
};

export function getRouter(): RouterWrapper {
  return ((getRootDeputyFrame()?.__APP__?.ROUTER ||
    {}) as unknown) as RouterWrapper;
}

export function getCurrentRoute(): RouterWrapperRoute {
  return (
    getFutureCurrentRoute() ||
    getRouter().currentRoute?.value ||
    getRouter().$route()
  );
}

export function getPreviousRoute(): RouterWrapperRoute {
  return getRouter().__previousRoute || ({} as RouterWrapperRoute);
}

export function getCurrentRouteParams(): RouterWrapperRouteParams {
  return getCurrentRoute().params || {};
}

export function setCurrentRouteParams(params?: RouterWrapperRouteParams): void {
  getCurrentRoute().params = { ...getCurrentRouteParams(), ...params };
}

export function getCurrentRouteQueryParams(): RouterWrapperRouteParams {
  return getCurrentRoute().query || {};
}

export function getCurrentRoutePath(): string {
  return getCurrentRoute().path || '';
}

export function getPreviousRouteFullPath(): string {
  return getPreviousRoute().fullPath || '';
}

export function getCurrentRouteFullPath(): string {
  return getCurrentRoute().fullPath || '';
}

export function getFutureCurrentRoute(): RouterWrapperRoute | undefined {
  return getRouter().__futureCurrentRoute;
}

export function fixRoute(
  route: string | WebappVueRoute = ''
): string | WebappVueRoute {
  if (typeof route === 'string') {
    // TODO: improve this code
    // this is to make sure all the legacy routes respect the new pattern like
    // instead of #team or /#team or team it will be /team
    const [beforeHash] = route.split('#');
    const routeToCheck = !!beforeHash.match(/^\w/g) ? beforeHash : route;

    return routeToCheck.replace(/(^\/\#\/|^\#\/|^\/\#|^\#|^\/+)/g, '/');
  }

  return route;
}

export function createWebappRoute(params: WebappVueRoute): WebappVueRoute {
  return {
    ...params,
    component: RouterFakeComponent,
    webappVueComponent: params.component,
    webappVueRedirect: params.redirect
      ? params.redirect instanceof Function
        ? params.redirect
        : (): WebappVueRoute['redirect'] => params.redirect
      : undefined,
    isWebappVueRoute: true,
  };
}

// TODO: remove this function after core-0-vue-router is fully released
export function setupRouterRetrofeed(
  routerInstace: RouterWrapper
): RouterWrapper {
  // TODO: this is necessary until we change all the route changes
  // fix the route before push
  const push = routerInstace.push;
  routerInstace.push = (route = ''): void => push(fixRoute(route));

  // TODO: this is necessary until vue2 router wrapper exists in the embeds
  routerInstace.$route = getCurrentRoute;
  routerInstace.$previousRoute = getPreviousRoute;
  routerInstace.pushDontTrigger = (route = ''): void =>
    getRouter().replace(route);
  routerInstace.off = (): boolean => true;
  routerInstace.$off = (): boolean => true;
  routerInstace.$on = (): boolean => true;

  return routerInstace;
}

// TODO: remove this function after core-0-vue-router is fully released
export function updateBackboneHistoryFragment(
  toRoute: RouterWrapperRoute
): void {
  const fragment = (toRoute.path || '').replace('/', '');

  window.Backbone = window.Backbone || {};
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.Backbone.history = window.Backbone.history || {};
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.Backbone.history.fragment = fragment;
}

export function getModalFromCurrentRoute(): string | undefined {
  const { queryParams } = getCurrentRoute();
  return String(queryParams.modal) || undefined;
}

export function removeModalFromCurrentRoute(): void {
  const { path, hash } = getCurrentRoute();
  const finalPath = !Array.isArray(path) ? path : hash;

  getRouter().replace(
    (finalPath || '')
      .replace(/[?&]modal=[^&#]*(#.*)?/, '')
      .replace(/\?+/, '&')
      .replace(/&/, '?')
  );
}
